import React from "react";
import ReactDOM from "react-dom/client";
import CareerGPX from "./CareerGPX";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CareerGPX />
  </React.StrictMode>
);
